// extracted by mini-css-extract-plugin
module.exports = {"demographics":"demographics_demographics__3SUW1","inner":"demographics_inner__d0bGd","demographicsContainer":"demographics_demographicsContainer__Z_I1a"};